import {COLORS} from "shared/consts";
import styled from "styled-components";
import {toRem} from "shared/helpers";
import {InformationIcon} from "shared/ui/icons/notificationIcons/informationIcon";
import {useNavigate} from "react-router-dom";

const DevicesInfoLink = styled.div`
    display: flex;
    align-items: center;
    gap: ${toRem(6)};
    color: ${COLORS.FG.DEFAULT};
    font-size: ${toRem(14)};
    font-weight: 400;
    line-height: ${20 / 14};
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.7;
    }

    svg {
        width: ${toRem(20)};
        height: ${toRem(20)};
        flex-shrink: 0;
    }
`;

export const DevicesTitleRight = () => {
    const navigate = useNavigate();

    const handleInfoClick = () => {
        navigate("/devices/info");
    };

    return (
        <DevicesInfoLink onClick={handleInfoClick}>
            <InformationIcon fill={COLORS.FG.DEFAULT} />
            <span>Подробнее об устройствах</span>
        </DevicesInfoLink>
    );
};

